import { SAPI_URL } from "@env";

export default {
  api: {
    domain:
      process.env.NODE_ENV === "development"
        ? SAPI_URL
        : SAPI_URL,
  },
};
